import { useTranslation } from "react-i18next";

const FloatingLanguageSelector = ({
  langDropdownOpen,
  setLangDropdownOpen,
  langRef,
  languages,
  changeLanguage,
  currentLanguage,
}) => {
  return (
    <div
      ref={langRef}
      className="fixed left-4 bottom-0 left-[30px] md:left-[50px] z-50"
      style={{ minWidth: 90 }}
      onMouseOver={() => setLangDropdownOpen(true)}
      onMouseLeave={() => setLangDropdownOpen(false)}
    >
      {!langDropdownOpen && (
        <div className="bg-black text-white rounded-lg shadow-lg cursor-pointer flex items-center p-4 gap-2 transition">
          <span className="text-xl">
            {languages.find((l) => l.code === currentLanguage)?.flag}
          </span>
          <span className="font-medium text-sm">
            {languages.find((l) => l.code === currentLanguage)?.label}
          </span>
        </div>
      )}
      {langDropdownOpen && (
        <div className="mt-2 bg-black rounded-lg shadow-lg py-1 w-full animate-fade-in">
          {languages.map((lang) => (
            <button
              key={lang.code}
              className={`flex items-center w-full px-3 py-2 gap-2 text-left text-sm transition text-white ${
                currentLanguage === lang.code
                  ? "font-bold bg-gray-800"
                  : "font-normal hover:bg-gray-900"
              }`}
              onClick={() => changeLanguage(lang.code)}
            >
              <span className="text-xl">{lang.flag}</span>
              <span>{lang.label}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default FloatingLanguageSelector;
